<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">我的收藏</span>
      </div>
    </div>
    <div class="Collect_cont"
         v-if="CollectList.length == 0">
      <ul class="NoneData">
        <p>
          <span>您还没有收藏过课程哟，快去找些感兴趣的课程吧！</span>
        </p>
      </ul>
    </div>
    <div v-else
         class="display_between marginTop20"
         v-for="(item, index) in CollectList"
         :key="index">
      <div class="pub_square"
           v-for="(itemn, indexn) in item"
           @click.stop="ToCoureDetail(itemn)"
           :key="indexn">
        <div class="pubs_img">
          <img class="pubs_img"
               :src="itemn.acr_PictResUrl" />
        </div>
        <div class="pubs_body">
          <div class="pubs_title"
               :title="itemn.title">
            {{ ellipsis(itemn.title, 15) }}
          </div>
          <div class="pubs_label display_between">
            <div></div>
            <div class="pubs_collect"
                 @click.stop="delcollect(itemn)">
              取消收藏
            </div>
          </div>
          <div class="display_between">
            <div class="pubs_tip">
              <span v-if="itemn.discountStatus == 0">￥{{ itemn.price }}</span>
              <span v-else>
                <span v-if="itemn.discountStatus == 2">免费</span>
                <span v-else>
                  <span v-if="itemn.discountStatus == 1">VIP专享</span>
                  <span v-if="itemn.discountStatus == 3">限时折扣</span>
                </span>
              </span>
            </div>
            <div class="pubs_rentou"><img src="/image/geren/ren.png" />{{ itemn.playSum }}</div>
          </div>
        </div>
      </div>
      <div class="pub_square1"
           v-for="zhw in 3 - item.length"
           :key="zhw"></div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash';
export default {
  inject: ['reload'],
  name: 'userMyCollection',
  data () {
    return {
      apiData: [],
      // 用户id
      AuthorId: '',
      CollectList: []
    };
  },
  created () {
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id;
    }
    this.getCollectCourse();
  },
  methods: {
    // 跳转详情
    ToCoureDetail (item) {
      window.open(this.httphelper.IsDebugCgphome()+'/detail?courseId=' + item.courseInfoId, "_blank")
      //   this.$router.push({
      //     path: '/AllCourse/AllCoursedetail',
      //     query: {
      //       courseId: item.id
      //     }
      //   });
    },
    // 获取收藏课程
    getCollectCourse () {
      this.httphelper
        .post('/api/CGPInfoApi/GetMyGpFavorites', {
          userId: this.AuthorId
        })
        .then(res => {
          this.CollectList = lodash.chunk(res.data.data, 3);
        });
    },
    // 取消收藏
    delcollect (item) {
      this.httphelper
        .post('/api/CGPInfoApi/DeleteGpFavorites', {
          courseId: item.courseInfoId,
          userId: item.userID
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: '取消收藏成功',
              type: 'success'
            });
            this.getCollectCourse();
            // this.reload();
          } else if (res.data.code == 245) {
            this.$message({
              message: '取消收藏失败',
              type: 'warning'
            });
          }
        });
    }
  }
};
</script>

<style scoped>
.NoneData {
    padding: 40px;
    text-align: center;
    color: #999;
    font-size: 18px;
    letter-spacing: 1px;
}
.pubs_collect:hover {
    cursor: pointer;
}
.pub_square1 {
    width: 300px;
    height: 280px;
    background: #ffffff;
    border-radius: 0px 0px 5px 5px;
    /* box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04); */
}
</style>
